import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiConnectorService } from "../api-connector.service";
import { ConfigService } from "../../config/config.service";
import {
  JoliooCheckResponse,
  JoliooRedemption,
  JoliooReservation,
  JoliooVoucher,
} from "./voucher.types";

@Injectable({
  providedIn: "root",
})
export class ApiConnectorJoliooService extends ApiConnectorService {
  constructor(
    public configService: ConfigService,
    public http: HttpClient,
  ) {
    super(configService);
  }

  private url(path: string): string {
    return this.configService.config.cms.url + "/api/jolioo/voucher/" + path;
  }

  /**
   * Reiner Lesezugriff — verändert den Gutschein nicht.
   */
  public check(code: string, pharmacy: string): Observable<JoliooCheckResponse> {
    return this.http.post<JoliooCheckResponse>(this.url("check"), {
      code,
      pharmacy,
    });
  }

  /**
   * Schritt 1: Betrag reservieren. Bucht noch nichts ab — erst confirm() tut das.
   *
   * Der idempotencyKey gilt für den gesamten Vorgang (reserve, confirm, cancel)
   * und muss über alle Retries gleich bleiben.
   */
  public reserve(
    code: string,
    pharmacy: string,
    value: number,
    idempotencyKey: string,
  ): Observable<JoliooReservation> {
    return this.http.post<JoliooReservation>(this.url("reserve"), {
      code,
      pharmacy,
      value,
      idempotency_key: idempotencyKey,
    });
  }

  /** Schritt 2a: Reservierung bestätigen — bucht endgültig ab. */
  public confirm(
    code: string,
    pharmacy: string,
    idempotencyKey: string,
  ): Observable<JoliooRedemption> {
    return this.http.post<JoliooRedemption>(this.url("confirm"), {
      code,
      pharmacy,
      idempotency_key: idempotencyKey,
    });
  }

  /** Schritt 2b: Reservierung verwerfen — der Betrag geht zurück. */
  public cancel(
    code: string,
    pharmacy: string,
    idempotencyKey: string,
  ): Observable<{ cancelled: boolean; voucher: JoliooVoucher }> {
    return this.http.post<{ cancelled: boolean; voucher: JoliooVoucher }>(
      this.url("cancel"),
      { code, pharmacy, idempotency_key: idempotencyKey },
    );
  }

}
